// @generated by protoc-gen-es v1.10.1 with parameter "target=ts,import_extension=none"
// @generated from file service/admin/crud/contact_crud_service_generated.proto (package service, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3 } from "@bufbuild/protobuf";
import { Contact } from "../../../entity/contact_pb";

/**
 * IndexContactArgs メッセージ
 *
 * @generated from message service.IndexContactArgs
 */
export class IndexContactArgs extends Message<IndexContactArgs> {
  /**
   * @generated from field: int32 offset = 1;
   */
  offset = 0;

  /**
   * @generated from field: int32 limit = 2;
   */
  limit = 0;

  constructor(data?: PartialMessage<IndexContactArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexContactArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "offset", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 2, name: "limit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexContactArgs {
    return new IndexContactArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexContactArgs {
    return new IndexContactArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexContactArgs {
    return new IndexContactArgs().fromJsonString(jsonString, options);
  }

  static equals(a: IndexContactArgs | PlainMessage<IndexContactArgs> | undefined, b: IndexContactArgs | PlainMessage<IndexContactArgs> | undefined): boolean {
    return proto3.util.equals(IndexContactArgs, a, b);
  }
}

/**
 * CreateContactArgs メッセージ
 *
 * @generated from message service.CreateContactArgs
 */
export class CreateContactArgs extends Message<CreateContactArgs> {
  /**
   * @generated from field: repeated entity.Contact contacts = 1;
   */
  contacts: Contact[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 3 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<CreateContactArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateContactArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contacts", kind: "message", T: Contact, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateContactArgs {
    return new CreateContactArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateContactArgs {
    return new CreateContactArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateContactArgs {
    return new CreateContactArgs().fromJsonString(jsonString, options);
  }

  static equals(a: CreateContactArgs | PlainMessage<CreateContactArgs> | undefined, b: CreateContactArgs | PlainMessage<CreateContactArgs> | undefined): boolean {
    return proto3.util.equals(CreateContactArgs, a, b);
  }
}

/**
 * ReadContactArgs メッセージ
 *
 * @generated from message service.ReadContactArgs
 */
export class ReadContactArgs extends Message<ReadContactArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  constructor(data?: PartialMessage<ReadContactArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadContactArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadContactArgs {
    return new ReadContactArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadContactArgs {
    return new ReadContactArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadContactArgs {
    return new ReadContactArgs().fromJsonString(jsonString, options);
  }

  static equals(a: ReadContactArgs | PlainMessage<ReadContactArgs> | undefined, b: ReadContactArgs | PlainMessage<ReadContactArgs> | undefined): boolean {
    return proto3.util.equals(ReadContactArgs, a, b);
  }
}

/**
 * UpdateContactArgs メッセージ
 *
 * @generated from message service.UpdateContactArgs
 */
export class UpdateContactArgs extends Message<UpdateContactArgs> {
  /**
   * @generated from field: repeated entity.Contact contacts = 1;
   */
  contacts: Contact[] = [];

  /**
   * @generated from field: bool allow_missing = 2 [json_name = "allow_missing"];
   */
  allowMissing = false;

  /**
   * @generated from field: bool force_execute = 3 [json_name = "force_execute"];
   */
  forceExecute = false;

  /**
   * @generated from field: bool skip_version_migration = 4 [json_name = "skip_version_migration"];
   */
  skipVersionMigration = false;

  constructor(data?: PartialMessage<UpdateContactArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateContactArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contacts", kind: "message", T: Contact, repeated: true },
    { no: 2, name: "allow_missing", jsonName: "allow_missing", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 3, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 4, name: "skip_version_migration", jsonName: "skip_version_migration", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateContactArgs {
    return new UpdateContactArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateContactArgs {
    return new UpdateContactArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateContactArgs {
    return new UpdateContactArgs().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateContactArgs | PlainMessage<UpdateContactArgs> | undefined, b: UpdateContactArgs | PlainMessage<UpdateContactArgs> | undefined): boolean {
    return proto3.util.equals(UpdateContactArgs, a, b);
  }
}

/**
 * DeleteContactArgs メッセージ
 *
 * @generated from message service.DeleteContactArgs
 */
export class DeleteContactArgs extends Message<DeleteContactArgs> {
  /**
   * @generated from field: repeated string ids = 1;
   */
  ids: string[] = [];

  /**
   * @generated from field: bool force_execute = 2 [json_name = "force_execute"];
   */
  forceExecute = false;

  constructor(data?: PartialMessage<DeleteContactArgs>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteContactArgs";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "ids", kind: "scalar", T: 9 /* ScalarType.STRING */, repeated: true },
    { no: 2, name: "force_execute", jsonName: "force_execute", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteContactArgs {
    return new DeleteContactArgs().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteContactArgs {
    return new DeleteContactArgs().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteContactArgs {
    return new DeleteContactArgs().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteContactArgs | PlainMessage<DeleteContactArgs> | undefined, b: DeleteContactArgs | PlainMessage<DeleteContactArgs> | undefined): boolean {
    return proto3.util.equals(DeleteContactArgs, a, b);
  }
}

/**
 * IndexContactReply メッセージ
 *
 * @generated from message service.IndexContactReply
 */
export class IndexContactReply extends Message<IndexContactReply> {
  /**
   * @generated from field: repeated entity.Contact contacts = 1;
   */
  contacts: Contact[] = [];

  constructor(data?: PartialMessage<IndexContactReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.IndexContactReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contacts", kind: "message", T: Contact, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): IndexContactReply {
    return new IndexContactReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): IndexContactReply {
    return new IndexContactReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): IndexContactReply {
    return new IndexContactReply().fromJsonString(jsonString, options);
  }

  static equals(a: IndexContactReply | PlainMessage<IndexContactReply> | undefined, b: IndexContactReply | PlainMessage<IndexContactReply> | undefined): boolean {
    return proto3.util.equals(IndexContactReply, a, b);
  }
}

/**
 * CreateContactReply メッセージ
 *
 * @generated from message service.CreateContactReply
 */
export class CreateContactReply extends Message<CreateContactReply> {
  constructor(data?: PartialMessage<CreateContactReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.CreateContactReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): CreateContactReply {
    return new CreateContactReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): CreateContactReply {
    return new CreateContactReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): CreateContactReply {
    return new CreateContactReply().fromJsonString(jsonString, options);
  }

  static equals(a: CreateContactReply | PlainMessage<CreateContactReply> | undefined, b: CreateContactReply | PlainMessage<CreateContactReply> | undefined): boolean {
    return proto3.util.equals(CreateContactReply, a, b);
  }
}

/**
 * ReadContactReply メッセージ
 *
 * @generated from message service.ReadContactReply
 */
export class ReadContactReply extends Message<ReadContactReply> {
  /**
   * @generated from field: repeated entity.Contact contacts = 1;
   */
  contacts: Contact[] = [];

  constructor(data?: PartialMessage<ReadContactReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.ReadContactReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "contacts", kind: "message", T: Contact, repeated: true },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): ReadContactReply {
    return new ReadContactReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): ReadContactReply {
    return new ReadContactReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): ReadContactReply {
    return new ReadContactReply().fromJsonString(jsonString, options);
  }

  static equals(a: ReadContactReply | PlainMessage<ReadContactReply> | undefined, b: ReadContactReply | PlainMessage<ReadContactReply> | undefined): boolean {
    return proto3.util.equals(ReadContactReply, a, b);
  }
}

/**
 * UpdateContactReply メッセージ
 *
 * @generated from message service.UpdateContactReply
 */
export class UpdateContactReply extends Message<UpdateContactReply> {
  constructor(data?: PartialMessage<UpdateContactReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.UpdateContactReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): UpdateContactReply {
    return new UpdateContactReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): UpdateContactReply {
    return new UpdateContactReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): UpdateContactReply {
    return new UpdateContactReply().fromJsonString(jsonString, options);
  }

  static equals(a: UpdateContactReply | PlainMessage<UpdateContactReply> | undefined, b: UpdateContactReply | PlainMessage<UpdateContactReply> | undefined): boolean {
    return proto3.util.equals(UpdateContactReply, a, b);
  }
}

/**
 * DeleteContactReply メッセージ
 *
 * @generated from message service.DeleteContactReply
 */
export class DeleteContactReply extends Message<DeleteContactReply> {
  constructor(data?: PartialMessage<DeleteContactReply>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "service.DeleteContactReply";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): DeleteContactReply {
    return new DeleteContactReply().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): DeleteContactReply {
    return new DeleteContactReply().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): DeleteContactReply {
    return new DeleteContactReply().fromJsonString(jsonString, options);
  }

  static equals(a: DeleteContactReply | PlainMessage<DeleteContactReply> | undefined, b: DeleteContactReply | PlainMessage<DeleteContactReply> | undefined): boolean {
    return proto3.util.equals(DeleteContactReply, a, b);
  }
}

